module.exports = __webpack_public_path__ + "img/kanto-logo-sm.706544cb.png";